import React, { useEffect, useState, useContext } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { customTheme, antellTheme, dpmTheme, eglobaltTheme, mickeyTheme, tovalTheme, monchisTheme, itacotyTheme, cordilleraTheme, sluciaTheme, mediplanTheme, ampacTheme, acisaTheme, abanTheme, unnakiTheme, efeteTheme, sanpatricioTheme, diprocarTheme,
pyainmobiliariaTheme, mariamTheme, automotiveTheme, inmobiliariagralTheme, foodCleaningTheme, craftTheme, kigaTheme, envacoTheme, fluoderTheme } from "./styles/themes";
import Login from "./pages/Login/Login";
import Navbar from "./components/Navbar";
import Comprobantes from "./pages/Comprobantes/Comprobantes";
import SnackBarAlert from "./components/snackbarAlert/SnackBarAlert";
import SignUp from "./pages/Form/SignUp";
import { UserInfoContext } from "./service/UserInfoContext";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import RedirectAccessToken from "./pages/RedirectAccessToken/RedirectAccessToken";
import './App.css';
import Consulta from "./pages/Consulta/Consulta";

function App() {
  const [userInfoState, updateUserInfoState] = useState({});
  const { state } = useContext(UserInfoContext);
  const [location, setLocation] = useState(window.location.origin);
  const [theme, setTheme] = useState(customTheme);

  // A wrapper for <Route> that redirects to the login
  // screen if you're not yet authenticated.
  const ProtectedRoute = ({ children }) => {
    if (!localStorage.getItem('isLoggin')) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  useEffect(() => {
    if (location.includes("modiga")) {
      setTheme(customTheme);
    } else if (location.includes("antell")) {
      setTheme(antellTheme);
    }else if (location.includes("dpm")) {
      setTheme(dpmTheme);
    }else if (location.includes("eglobalt")) {
      setTheme(eglobaltTheme);
    }else if (location.includes("mickey")) {
      setTheme(mickeyTheme);
    }else if (location.includes("toval")) {
      setTheme(tovalTheme);
    }else if (location.includes("monchis")) {
      setTheme(monchisTheme);
    }else if (location.includes("itacoty")) {
      setTheme(itacotyTheme);
    }else if (location.includes("dcordillera")) {
      setTheme(cordilleraTheme);
    }else if (location.includes("opticasantalucia")) {
      setTheme(sluciaTheme);
    }else if (location.includes("mediplan")) {
      setTheme(mediplanTheme);
    }else if (location.includes("ampac")) {
      setTheme(ampacTheme);
    }else if (location.includes("acisa")) {
      setTheme(acisaTheme);
    }else if (location.includes("aban")) {
      setTheme(abanTheme);
    }else if (location.includes("unnaki")) {
      setTheme(unnakiTheme);
    }else if (location.includes("efete")) {
      setTheme(efeteTheme);
    }else if (location.includes("sanpatricio")) {
      setTheme(sanpatricioTheme);
    }else if (location.includes("diprocar")) {
      setTheme(diprocarTheme);
    }else if (location.includes("pyainmobiliaria")) {
      setTheme(pyainmobiliariaTheme);
    }else if (location.includes("mariam")) {
      setTheme(mariamTheme);
    }else if (location.includes("automotive")) {
      setTheme(automotiveTheme);
    }else if (location.includes("inmobiliariageneral")) {
      setTheme(inmobiliariagralTheme);
    }else if (location.includes("foodcleaning")) {
      setTheme(foodCleaningTheme);
    }else if (location.includes("craft")) {
      setTheme(craftTheme);
    }else if (location.includes("envaco")) {
      setTheme(envacoTheme);
    }else if (location.includes("fluoder")) {
      setTheme(fluoderTheme);
    }else if (location.includes("test") || location.includes("prod")) {
      setTheme(kigaTheme);
    }
  }, []);

  return (
    <UserInfoContext.Provider value={{ state: userInfoState, update: updateUserInfoState }}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <div className="App">
          <SnackBarAlert />
          <BrowserRouter>
            <Routes>
              {location.includes("antell") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("eglobalt") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("toval") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("monchis") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("itacoty") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("opticasantalucia") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("mediplan") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("ampac") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("acisa") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("aban") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("unnaki") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("efete") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("sanpatricio") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("diprocar") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("pyainmobiliaria") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("mariam") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("automotive") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("inmobiliariageneral") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("foodcleaning") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("craft") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("envaco") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              {location.includes("fluoder") &&
                <>
                  <Route path='/consultacomprobante' element={<Consulta />} />
                </>
              }
              <><Route path='/' element={<Login />} />
                <Route path='/comprobantes' element={<RedirectAccessToken />} />
                <Route path='/registrarme' element={<SignUp />} />
                <Route path='/listacomprobantes' element={<Navbar />}>
                  <Route index element={<ProtectedRoute>
                    <Comprobantes />
                  </ProtectedRoute>} />
                </Route>
                <Route path='*' element={<Login />} />
              </>

            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </UserInfoContext.Provider>
  );



}

export default App;
